import api from './api';

const RecruitmentService = {
    getAllJobs: async () => {
        try {
            const response = await api.get('/api/jobs?size=6');
            const data = response.data;
            return Array.isArray(data) ? data : (data?.content || data?.items || data?.data || []);
        } catch (error) {
            console.error('Error fetching jobs:', error);
            throw error;
        }
    },

    getJobBySlug: async (idOrSlug) => {
        try {
            const response = await api.get(`/api/jobs/${idOrSlug}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching job details:', error);
            throw error;
        }
    }
};

export default RecruitmentService;



